import axios from 'axios';
import {CUSTODIA_GARANTIA_SERVICE_CONTEXT} from "../../../utils/constants/ContextConstants";

export class SettlementService {
    getSettlement(
        loanId,
        flowId) {
        return axios.get('/appapv/getSettlement.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                idFolioPrest: loanId,
                idFlujo: flowId,
            }
        }).then(res => res.data.payload);
    }

    resendGss(rowData) {
        let url = rowData['flujo'] === 'Concertados' ? 'resendSettlementNewLoanGSS.action' : 'resendSettlementMaturityGSS.action';

        return axios.post('/appapv/' + url, {},
            {
                params: {
                    idFolioPrest: rowData['idFolioPrest']
                }
            }).then(res => res.data);
    }

    resendTrustInstruction(rowData) {
        let url = 'resend';

        return axios.post(CUSTODIA_GARANTIA_SERVICE_CONTEXT + url, {},
            {
                params: {
                    referenceId: rowData.referenceId
                }
            }).then(res => res.data);
    }

    settlementGss(
        rowData
    ) {

        return axios.post('/appapv/updateSettlementBnmx.action', {},
            {
                params: {
                    idFolioPrest: rowData['idFolioPrest']
                }
            }).then(res => res.data);
    }
}
